import { useWindowWidth as _useWindowWidth } from '@wojtekmaj/react-hooks'

import { DEFAULT_WINDOW_WIDTH } from '@/constants/general'

export const useWindowWidth = (defaultValue: number = DEFAULT_WINDOW_WIDTH) => {
  const windowWidth = _useWindowWidth()
  return windowWidth === null ? defaultValue : windowWidth
}
